import apiTrainingGroups from '@/api/training-groups'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getTrainingGroupsTrainerStart:
    '[training groups trainer] Get training groups trainer start',
  getTrainingGroupsTrainerSuccess:
    '[training groups trainer] Get training groups trainer success',
  getTrainingGroupsTrainerFailure:
    '[training groups trainer] Get training groups trainer failure',
}

export const actionTypes = {
  getTrainingGroupsTrainer:
    '[training groups trainer] Get training groups trainer',
}

const mutations = {
  [mutationTypes.getTrainingGroupsTrainerStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingGroupsTrainerSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingGroupsTrainerFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getTrainingGroupsTrainer](context, params) {
    context.commit(mutationTypes.getTrainingGroupsTrainerStart)
    return new Promise((resolve) => {
      apiTrainingGroups
        .getTrainingGroupsListForTrainer(params)
        .then((response) => {
          context.commit(
            mutationTypes.getTrainingGroupsTrainerSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingGroupsTrainerFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
